import { Component, OnInit, AfterViewInit, ViewChild, ɵConsole, ChangeDetectorRef, NgZone } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { MediaObserver, MediaChange } from '@angular/flex-layout';

import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig } from '@angular/material/legacy-dialog';
import { MatStepper } from '@angular/material/stepper';

import { DeviceDetectorService } from 'ngx-device-detector';

import { QuickPayPaymentConfirmationDialogComponent } from '../quick-pay-payment-confirmation-dialog/quick-pay-payment-confirmation-dialog.component';

import { environment } from '../../../environments/environment';
import { ErrorHandler, HandleError } from '../../services/error-handler.service';
import { QuickPayService } from '../../services/quickpay.service';
import { QuickPayPaymentService } from '../../services/quickpay-payment.service';

import { QuickPayPaymentSelectType, QuickPayPaymentSelected } from '../quick-pay-payment-note-list/quick-pay-payment-note-list.component';
import { OpenNotesQuickPayPaymentInfoListItem, PaymentDetail, QPaymentConfirmationDialogData } from 'src/app/models/quickpay';

export interface QP_PaymentSelected {
  paymentSelectType: QuickPayPaymentSelectType;
  selectedId: any;
  selectedData: OpenNotesQuickPayPaymentInfoListItem[];
}
@Component({
  selector: 'app-quick-pay-payment',
  templateUrl: './quick-pay-payment.component.html',
  styleUrls: ['./quick-pay-payment.component.scss']
})
export class QuickPay_PaymentComponent implements OnInit {
  @ViewChild('quickPaypaymentStepper') quickPaypaymentStepper: MatStepper;

  private _handleError: HandleError;
  private _logging = environment.logging;
  private _display = environment.display;

  isBrowserIE = /msie\s|trident\//i.test(window.navigator.userAgent);

  userFullName = '';
  participantIdString = '';
  acct_type: string = '';
  participantId: string = '';
  lastName: string = null;
  zipCode: string = null;

  showSpinner = false;

  step1Complete = false;
  step2Complete = false;
  step3Complete = false;
  step1Editable = true;
  step2Editable = true;
  step3Editable = true;

  paymentSelectType = QuickPayPaymentSelectType;
  quickpaypaymentSelected: QP_PaymentSelected = {
    paymentSelectType: null,
    selectedId: null,
    selectedData: []
  };

  paymentAmountString: string = null;
  paymentAmountValue: number = null;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _errorHandler: ErrorHandler,
    private _quickPayService: QuickPayService,
    private _quickPay_paymentService: QuickPayPaymentService,
    private _deviceService: DeviceDetectorService,
    public paymentConfirmationDialog: MatDialog,
    public media: MediaObserver,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone
  ) {
    this._handleError = _errorHandler.createHandleError('QuickPayPaymentComponent');
    this.userFullName = this._quickPayService.getFullName();
    this.acct_type = this._quickPayService.getAcctType();
    this.participantId = this._quickPayService.getParticipantId();
    this.participantIdString = this.participantId.toString();
    this.lastName = this._quickPayService.getLastName();
    this.zipCode = this._quickPayService.getZipCode();

    const routeUrl = _route.snapshot.url.join('');
    if (routeUrl.toLowerCase().includes('payineligible') && this._quickPayService.getNoteId() !== null) {
      this.handleIneligibleNotePayment(this.acct_type, this.participantId, this.lastName, this.zipCode);
    }
    this.scrollToTop();
  }

  ngOnInit() {}

  handleIneligibleNotePayment(acct_type: string, participantId: string, lastName: string, zipCode: string): void {
    this.showSpinner = true;
    this._quickPay_paymentService.getOpenNotesQuickPayPaymentInfoList(acct_type, participantId, lastName, zipCode).subscribe(
      resultArray => {
        let quickpaypaymentSelected: QP_PaymentSelected;
        quickpaypaymentSelected = {
          paymentSelectType: QuickPayPaymentSelectType.Note,
          selectedId: participantId,
          selectedData: this._getFilteredOpenNotesQuickPayPaymentInfoListItems(participantId, resultArray)
        };

        if (this._logging.serviceCallTraceLog) {
          console.log('QuickPayPaymentComponent.handleIneligibleNotePayment :: result.length = ' + resultArray.length);
        }
        if (this._logging.serviceDataTraceLog) {
          console.log('QuickPayPaymentComponent.handleIneligibleNotePayment :: result = ' + JSON.stringify(resultArray));
        }
        this.showSpinner = false;
        this._quickPayService.clearNoteId();
        this.step1Editable = false;
        this.onQuickPayPaymentNoteListSelected(quickpaypaymentSelected);
      },
      error => this._handleError('handleIneligibleNotePayment', error)
    );
  }

  onQuickPayPaymentNoteListSelected(quickpaypaymentSelected: QP_PaymentSelected) {
    if (this._quickPayService.isLoggedIn()) {
      if (
        quickpaypaymentSelected !== undefined &&
        quickpaypaymentSelected !== null &&
        quickpaypaymentSelected.selectedId !== null &&
        quickpaypaymentSelected.selectedId.toString().length > 0
      ) {
        this.quickpaypaymentSelected = quickpaypaymentSelected;
        this.step1Complete = true;
        setTimeout(() => {
          this.quickPaypaymentStepper.next();

          const stepId = this.quickPaypaymentStepper._getStepLabelId(this.quickPaypaymentStepper.selectedIndex);
          const stepElement = document.getElementById(stepId);
          if (stepElement) {
            setTimeout(() => {
              stepElement.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' });
            }, 250);
          }
        });
      } else {
        this.quickpaypaymentSelected = {
          paymentSelectType: null,
          selectedId: null,
          selectedData: []
        };
        this.step1Complete = false;
      }
    }
  }

  public onQuickPayPaymentAmountDataComplete(event: any) {
    if (this.quickPaypaymentStepper !== undefined && this.quickPaypaymentStepper !== null) {
      // const stepId = this.quickPaypaymentStepper._getStepLabelId(this.quickPaypaymentStepper.selectedIndex);
      const stepId = this.quickPaypaymentStepper._getStepLabelId(0);
      const stepElement = document.getElementById(stepId);
      if (stepElement) {
        setTimeout(() => {
          stepElement.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' });
        }, 250);
      }
    }
  }

  onQuickPayPaymentAmountSelected(quickpay_paymentAmount: number) {
    if (this._quickPayService.isLoggedIn()) {
      if (quickpay_paymentAmount !== undefined && quickpay_paymentAmount !== null && quickpay_paymentAmount > 0) {
        this.paymentAmountString = quickpay_paymentAmount.toFixed(2);
        this.paymentAmountValue = quickpay_paymentAmount;
        this.step2Complete = true;
        setTimeout(() => {
          this.quickPaypaymentStepper.next();
        });
      } else {
        this.paymentAmountString = null;
        this.paymentAmountValue = null;
        this.step2Complete = false;
      }
    }
  }

  public onQuickPayPaymentFormDataComplete(event: any) {
    // const stepId = this.quickPaypaymentStepper._getStepLabelId(this.quickPaypaymentStepper.selectedIndex);
    const stepId = this.quickPaypaymentStepper._getStepLabelId(1);
    const stepElement = document.getElementById(stepId);
    if (stepElement) {
      setTimeout(() => {
        stepElement.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' });
      }, 250);
    }
  }

  onQuickPayPaymentSubmitted(paymentDetail: PaymentDetail) {
    if (this._quickPayService.isLoggedIn()) {
      this.cdr.markForCheck();
      this.cdr.detectChanges();
      this.ngZone.run(() => {
        setTimeout(() => {
          this.openPaymentConfirmationDialog(paymentDetail);
        }, 0);
      });
    }
  }

  onQuickPayPaymentCanceled(): void {
    if (this._quickPayService.isLoggedIn()) {
      this.step1Complete = false;
      this.step2Complete = false;
      this.step3Complete = false;
      this.quickPaypaymentStepper.reset();
    }
  }

  cancelPaymentNow(): void {
    if (this._quickPayService.isLoggedIn()) {
      this.step1Complete = false;
      this.step2Complete = false;
      this.step3Complete = false;
      this.quickPaypaymentStepper.reset();

      if (this._logging.navigationTraceLog) {
        console.log('QuickPayPaymentComponent.cancelPaymentNow');
      }
      this._router.navigate(['']);0
10    }
  }

  openPaymentConfirmationDialog(paymentDetail: PaymentDetail): void {
    const paymentConfirmationDialogData: QPaymentConfirmationDialogData = this._quickPay_paymentService.getNewQuickPayPaymentConfirmationDialogData();
    paymentConfirmationDialogData.dialogTitle = 'Quick Pay';
    paymentConfirmationDialogData.paymentDetail = paymentDetail;

    if (this._logging.navigationTraceLog) {
      console.log('QuickPayPaymentComponent.openQuickPayPaymentConfirmationDialog :: Dialog Opened');
    }

    // May need to use screen height as the width if the device browser does not flip the screen width & height on orientation changes
    // const useScreenHeightAsWidth: boolean = window.innerWidth > window.innerHeight && screen.width < screen.height;
    // const screenWidth: number = useScreenHeightAsWidth ? screen.height : this._deviceService.isDesktop() ? window.innerWidth : screen.width;

    // let matDialogConfig: MatDialogConfig;
    // if (screenWidth < this._display.dialogDisplayDialogTriggerWidth) {
    //   matDialogConfig = {
    //     width: '95%',
    //     height: '75%',
    //     disableClose: true,
    //     data: paymentConfirmationDialogData
    //   };
    // } else {
    //   matDialogConfig = {
    //     width: '40%',
    //     disableClose: true,
    //     data: paymentConfirmationDialogData
    //   };
    // }

    const matDialogConfig: MatDialogConfig = {
        width: '95%',
        height: '95%',
        disableClose: true,
        maxWidth: '100vw',
        maxHeight: '100vh',
        data: paymentConfirmationDialogData
    };

    const dialogRef = this.paymentConfirmationDialog.open(QuickPayPaymentConfirmationDialogComponent, matDialogConfig);

    dialogRef.afterClosed().subscribe(returnData => {
      if (this._logging.navigationTraceLog) {
        console.log('QuickPayPaymentComponent.openQuickPayPaymentConfirmationDialog :: Dialog Closed');
      }

      const paymentConfirmationDialogDataResponse: QPaymentConfirmationDialogData = returnData;
      if (
        paymentConfirmationDialogDataResponse !== undefined &&
        paymentConfirmationDialogDataResponse !== null &&
        paymentConfirmationDialogDataResponse.paymentOk !== undefined &&
        paymentConfirmationDialogDataResponse.paymentOk !== null &&
        paymentConfirmationDialogDataResponse.paymentOk === true
      ) {
        this.step3Complete = true;
        if (this._logging.navigationTraceLog) {
          console.log('QuickPayPaymentComponent.openQuickPayPaymentConfirmationDialog');
        }
        this._router.navigate(['']);
      } else {
        this.step3Complete = false;
      }
    });
  }

  scrollToTop() {
    const contentStart = document.getElementsByClassName('mat-sidenav-content');
    if (contentStart.length > 0) {
      contentStart[0].scrollTop = 0;
    }
  }

  private _getFilteredOpenNotesQuickPayPaymentInfoListItems(
    selectedNoteId: string,
    openNotesQuickPayPaymentInfoList: OpenNotesQuickPayPaymentInfoListItem[]
  ): OpenNotesQuickPayPaymentInfoListItem[] {
    let selectedData: OpenNotesQuickPayPaymentInfoListItem[] = [];
    selectedData = openNotesQuickPayPaymentInfoList.filter(x => x.noteId.toString() === selectedNoteId);
    return selectedData;
  }
}
